import { render, staticRenderFns } from "./DeleteLocation.vue?vue&type=template&id=889323c6&"
import script from "./DeleteLocation.vue?vue&type=script&lang=ts&"
export * from "./DeleteLocation.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteLocation.vue?vue&type=style&index=0&id=889323c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports